<template>
    <!-- 穿纱工报表 -->
    <div class="rzy-page">
        <el-date-picker v-model="selectMonth" type="month" placeholder="选择月" @change="changeMonth" />
        <el-button type="success" @click="initExcel('chuanShaTable')">导出Excel</el-button>
        <el-button type="primary" @click="initPrint('chuanShaTable')">打印</el-button>
        <el-button type="primary" @click="toBatchPrint">批量打印</el-button>

        <el-table :data="chuanShaList" :header-cell-style="{'text-align':'center'}" id="chuanShaTable"
            :cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600">
            <el-table-column label="员工">
                <template slot-scope="data">
                    <el-link type="primary" @click="goToMonthDetails(data.row)">{{data.row.username}}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="类型" prop="roleName" />
            <el-table-column label="卡号" prop="cardNumber" />
            <el-table-column label="总工时" prop="sumHour" />

            <el-table-column label="有效工时" prop="validTime" />
            <el-table-column label="开机率" prop="poweronRate" />

            <el-table-column label="次数" prop="totalTimes" />
            <el-table-column label="日均次数" prop="avgTimes" />

            <el-table-column label="日均时长" prop="avgHour" />
            <el-table-column label="天数" prop="days" />

            <!--        <el-table-column label="排名">
          <template slot-scope="data">
            {{data.$index + 1}}
          </template>
        </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
    import api from '@/api/factory/statistics/worker'
    export default {
        name: 'chuanShaList',
        data() {
            return {
                chuanShaList: [],
                selectMonth: '',
                lastDate: 0
            }
        },
        methods: {
            // 获取当前月所有穿纱工的打卡数据
            getNowList() {
                const now = new Date()
                this.selectMonth = now
                this.getChuanShaList(this.utils.getFirstTimeByMonth(now.getTime()), this.utils.getLastTimeByMonth(now
                    .getTime()))
            },
            // 获取开始到结束时间的穿纱工打卡数据
            getChuanShaList(startTime, endTime) {
                const role = this.$enum.roleObj.chuansha.value
                api.getList({
                    role,
                    startTime,
                    endTime
                }).then(res => {
                    if (this.utils.isNowMonth(startTime)) {
                        this.lastDate = new Date().getDate()
                    } else {
                        this.lastDate = new Date(endTime).getDate()
                    }
                    this.chuanShaList = this.formatChuanShaInfo(res.data)
                })
            },
            // 格式化打卡数据
            formatChuanShaInfo(response) {
                // 按工人ID对返回数据分组
                var groupByWorkerId = this._.groupBy(response, (item) => {
                    return item.workerId
                })
                var formatArr = []
                for (var workerId in groupByWorkerId) {
                    var workerInfo = groupByWorkerId[workerId]
                    // 按日期对工人的打卡记录分组
                    var groupByDaily = this._.groupBy(workerInfo, (info) => {
                        return new Date(info.startTime).getDate()
                    })
                    // console.log("groupByDaily=", groupByDaily)

                    var sum = 0 // hongmj: 总工时
                    var attendanceDays = 0 // hongmj: 出勤天数?
                    let sumValitTime = 0 // hongmj: 总有效工时
                    for (var date in groupByDaily) {
                        var oneDay = groupByDaily[date]
                        // console.log("oneDay=", oneDay)
                        var workingHour = this.computeWorkingHour(oneDay)
                        sum += Number(workingHour)
                        attendanceDays++
                        //追加有效工时--sta
                        let m_validTime = this.computeValidTime(oneDay)
                        sumValitTime += Number(m_validTime)
                        //追加有效工时--end
                    }
                    const formatObj = {
                        workerId: workerInfo[0].workerId,
                        username: workerInfo[0].username,
                        cardNumber: workerInfo[0].cardNumber, // 卡号
                        role: workerInfo[0].role,
                        roleName: this.$enum.roleObj.chuansha.name, // 类型
                        // 若去掉小时则要修改按工时排序的逻辑，除非不去空格
                        sumHour: `${sum.toFixed(2)} 小时`, // 总工时
                        //追加有效工时--sta
                        validTime: `${sumValitTime.toFixed(2)} 小时`,
                        poweronRate: (sum==0)? `0%` : `${(sumValitTime/sum*100).toFixed(2)}%`,
                        //追加有效工时--end
                        avgHour: `${(sum / attendanceDays).toFixed(2)} 小时/天`, // 平均工时
                        days: attendanceDays + '天', // 出勤

                        totalTimes: workerInfo.length, // 总次数=数组长度
                        avgTimes: (workerInfo.length / attendanceDays).toFixed(2) // 日均次数=总次数/天数
                    }
                    formatArr.push(formatObj)
                }
                // 按总工时排序
                formatArr = this._.sortBy(formatArr, obj => {
                    return -obj.sumHour.split(' ')[0]
                })
                return formatArr
            },
            // 一天中可能有多次上班 早班，夜班，故将工时计算逻辑抽出。
            computeWorkingHour(oneDay) {
                var sumTime = 0
                oneDay.forEach(item => {
                    sumTime += item.totalTime //是秒
                })
                // console.log('sumTime=', sumTime)
                return (sumTime / 3600).toFixed(2)
            },

            //追加有效工时--sta
            //计算1天中的有效工时
            computeValidTime(oneDay) {
                var sumTime = 0
                oneDay.forEach(item => {
                    sumTime += item.validTime //validTime是秒
                })
                // console.log('sumTime=', sumTime)
                return (sumTime / 3600).toFixed(2)
            },
            //追加有效工时--end

            // 选择月份
            changeMonth(val) {
                const selectTime = val.getTime()
                this.getChuanShaList(this.utils.getFirstTimeByMonth(selectTime), this.utils.getLastTimeByMonth(
                    selectTime))
            },
            // 导出excel初始化
            initExcel(id) {
                const select = new Date(this.selectMonth)
                const year = select.getFullYear()
                const month = select.getMonth() + 1
                this.utils.exportExcel(id, `${year}年${month}月穿纱工报表`)
            },
            // 去月详情界面
            goToMonthDetails(row) {
                const id = row.workerId
                this.$router.push({
                    path: `/statistics/workerMonthDetails/${this.$enum.roleObj.chuansha.value}/${id}/${this.selectMonth.getTime()}`
                })
            },
            // 在打印当前报表前，拼接title
            initPrint(id) {
                var selectMonth = new Date(this.selectMonth)
                const year = selectMonth.getFullYear()
                const month = selectMonth.getMonth() + 1
                this.utils.printTable(id, `${year}年${month}月&nbsp;穿纱工考勤统计表`)
            },
            // 跳转至批量打印界面
            toBatchPrint() {
                const routeData = this.$router.resolve({
                    path: `/statistics/workerCountBatchPrint/${this.$enum.roleObj.chuansha.value}/${this.selectMonth.getTime()}`
                })
                window.open(routeData.href, '_blank')
            }
        },
        created() {
            this.getNowList()
        },
        mounted() {
            console.log(this.selectMonth)
        }
    }
</script>

<style lang="scss"></style>
